import { StrictMode } from "react";
import { createRoot } from "react-dom/client";
import { registerSW } from "virtual:pwa-register";

import { DEFAULT_VERSION } from "@excalidraw/common";

import "../excalidraw-app/sentry";

import ExcalidrawApp from "./App";

const buildVersion =
  import.meta.env.VITE_APP_BUILD_VERSION ||
  import.meta.env.VITE_APP_GIT_SHA ||
  DEFAULT_VERSION;

window.__EXCALIDRAW_SHA__ = buildVersion;

const versionMeta = document.querySelector<HTMLMetaElement>('meta[name="version"]');
if (versionMeta) {
  versionMeta.content = buildVersion;
}
const rootElement = document.getElementById("root")!;
const root = createRoot(rootElement);
registerSW();
root.render(
  <StrictMode>
    <ExcalidrawApp />
  </StrictMode>,
);
